module.exports = __webpack_public_path__ + "static/img/laishang.f3ef871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/laishang.png
// module id = RZfz
// module chunks = 93